import { ACCOUNT_LINKS } from '@/constants/links'
import { usePathname } from '@/i18n/routing'
import { useTranslations } from 'next-intl'

export const useAccountLinks = () => {
  const t = useTranslations('account.sidebar')
  const pathname = usePathname()

  const links = [
    {
      name: t('profile'),
      isActive: pathname === ACCOUNT_LINKS.index.href,
      ...ACCOUNT_LINKS.index,
    },
    {
      name: t('security'),
      isActive: pathname === ACCOUNT_LINKS.security.href,
      ...ACCOUNT_LINKS.security,
    },
    {
      name: t('settings'),
      isActive: pathname === ACCOUNT_LINKS.settings.href,
      ...ACCOUNT_LINKS.settings,
    },
    {
      name: t('more'),
      isActive: pathname === ACCOUNT_LINKS.more.href,
      ...ACCOUNT_LINKS.more,
    },
  ]

  return links
}
